import axios, { AxiosError } from 'axios'
import { useEffect } from 'react'

const reportApiClient = axios.create({
  baseURL: process.env.REACT_APP_REPORT_API_URL,
})

type Props = {
  children: JSX.Element
}

const errorHandler = (error: AxiosError) => {
  const statusCode = error.response?.status

  if (error.code === 'ERR_CANCELED') {
    return Promise.resolve()
  }

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.error(error)
  }

  return Promise.reject(error)
}

const AxiosClient = ({ children }: Props) => {
  console.log('add interceptors')
  const reportRequestInterceptors = reportApiClient.interceptors.request.use(
    async (config) => {
      // console.log('request to', config.url, config.data)
      const username = process.env.REACT_APP_REPORT_API_USERNAME
      const password = process.env.REACT_APP_REPORT_API_PASSWORD
      config.headers.Authorization = `Basic ${btoa(username + ':' + password)}`
      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )

  const reportResponseInterceptors = reportApiClient.interceptors.response.use(
    (response) => {
      // console.log('response from', response.request.responseURL, response.data)
      if (response.data.errors?.length) {
        console.log(response.data.errors[0].message)
        return Promise.reject(response.data.errors[0].message)
      }
      return response
    },
    (error) => {
      console.log('intercept response error', error.request.responseURL, error)
      return errorHandler(error)
    },
  )

  useEffect(() => {
    return () => {
      console.log('remove interceptors')
      reportApiClient.interceptors.response.eject(reportRequestInterceptors)
      reportApiClient.interceptors.response.eject(reportResponseInterceptors)
    }
  }, [reportRequestInterceptors, reportResponseInterceptors])

  return children
}

export { AxiosClient, reportApiClient }
